import './index.css'
import { Form } from 'semantic-ui-react'
import { ScanditRadioProps } from './types'
import ScanditRadioLabel from './ScanditRadioLabel'

const ScanditRadio = ({ id, name, title, description, image, value, checked, onChange }: ScanditRadioProps) => {
  return (
    <Form.Radio
      id={id}
      name={name}
      label={<ScanditRadioLabel id={id} image={image} title={title} description={description} />}
      value={value}
      checked={checked}
      onChange={onChange}
    />
  )
}

export default ScanditRadio
